<template>
  <div v-if="model.write_off_detail">
    <layout-panel>
      <span slot="header">{{title}}</span>
      <el-form
        ref="form"
        :model="model"
        size="medium"
        label-width="80px"
      >
        <el-row :gutter="20" class="invoice-row">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-tooltip
            class="item"
            effect="dark"
            content="没有项目编号则留空"
            placement="top"
          >
            <el-col :span="2">项目编号</el-col>
          </el-tooltip>
          <el-col :span="3">费用承担部门</el-col>
          <el-col :span="3">一级科目</el-col>
          <el-col :span="3">二级科目</el-col>
          <el-col :span="2">发票类型</el-col>
          <el-col :span="2">税率%</el-col>
          <el-col :span="2">含税冲销金额</el-col>
          <el-col :span="2">发票张数</el-col>
          <el-col :span="2">摘要</el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="1">&nbsp;</el-col>
        </el-row>
        <br />

        <el-row
          :gutter="20"
          v-for="(detailItem, itemIndex) in model.write_off_detail"
          :key="itemIndex"
          class="invoice-row"
          style="margin-top:5px"
        >
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{ itemIndex + 1 }}
          </el-col>

          <!-- 项目编号 -->
          <el-col key="project_id" :span="2">
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                detailItem.project_id > 0
                  ? detailItem.project_name + '/' + detailItem.project_number
                  : ''
              "
              placement="top"
            >
              <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
            </el-tooltip>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_id" :span="3">
            <span>{{detailItem.department_name}}</span>
          </el-col>

          <!--一级科目-->
          <el-col :span="3">
            <el-select
              v-model="detailItem.first_subject"
              @change="val => writeOffFirstSubjectChange(val, itemIndex)"
            >
              <el-option
                v-for="(label, value) in originFirstSubjects"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--二级科目-->
          <el-col :span="3">
            <el-select v-model="detailItem.second_subject">
              <el-option
                v-for="(label, value) in writeOffSecondSubjects[itemIndex]"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--发票类型-->
          <el-col :span="2">
            <el-select
              v-model="detailItem.invoice_type"
              @change="val => writeOffInvoiceTypeChange(val, itemIndex)"
            >
              <el-option
                v-for="(label, value) in invoiceType"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--税率-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <el-input
              :disabled="detailItem.invoice_type === 1"
              placeholder="请输入"
              v-model="detailItem.tax_rate"
            ></el-input>
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <el-input
              placeholder="请输入"
              v-model="detailItem.amount"
            ></el-input>
          </el-col>
          <!--发票张数-->
          <el-col :span="2">
            <el-input
              placeholder="请输入"
              v-model="detailItem.invoice_count"
            ></el-input>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <el-input placeholder="请输入" v-model="detailItem.desc"></el-input>
          </el-col>
        </el-row>
        <br />
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="16">
            <p style="padding: 0; margin:0; text-align: right;">
              冲销金额合计：
            </p>
          </el-col>
          <el-col :span="2">
            ￥{{ totalWriteOffAmount | seperateThousandsToFixed(2) }}
          </el-col>
          <el-col :span="2">
            {{ totalWriteOffInvoiceCount }}
          </el-col>
        </el-row>

        <el-form-item label="附件" prop="attached_file">
          <AttachedFiledUpload :fileList="model.attached_file" :uploadParams="uploadParams" url="finCenterUploadPaymentApplyFile" />
        </el-form-item>
        <el-form-item label="核销说明" prop="desc">
          <el-input v-model="model.desc" placeholder="请输入核销说明"></el-input>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>


<script>

import AttachedFiledUpload from '../../payment-approval/components/PaymentAttachedFileUpload.vue'
const WRITEOFFDETIALITEM = {
  project_id: null,
  project_number: null,
  department_id: null,
  department_name: null,
  first_subject: null,
  second_subject: null,
  invoice_type: null,
  tax_rate: null,
  amount: null,
  invoice_count: null,
  desc: null,
  canSelectDepartment: true,
}

export default {
  components: {
    AttachedFiledUpload
  },
  props: {
    title: {
      type: String,
      default: '新增冲销',
    },
    id: {
      type: Number | String,
      default: 0
    },
    model: {
      type: Object,
      required: true,
      default: () => {},
    },
    projectNames: {
      type: Object,
      required: true,
      default: () => {},
    },
    originFirstSubjects: {
      type: Object,
      required: true,
      default: () => {},
    },
    originSecondSubjects: {
      type: Object,
      required: true,
      default: () => {},
    },
    writeOffAssociatedRelationships: {
      type: Object,
      required: true,
      default: () => {},
    },
    writeOffSecondSubjects: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  // watch: {
  //   data: {
  //     immediate: true,
  //     handler (val) {
  //       this.setupModel(val)
  //     }
  //   }
  // },
  computed: {
    ...Vuex.mapState({
      invoiceType: state => state.paymentManager.invoiceType,
    }),
    // 冲销金额合计
    totalWriteOffAmount () {
      this.model.amount = this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
      return this.model.amount
    },

    // 发票数量合计
    totalWriteOffInvoiceCount () {
      return this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
    // 上传附件 参数
    uploadParams () {
      return {apply_id: this.id}
    }
  },
  data () {
    return {
      // model: {
      //   attached_file: [],
      //   amount: null,
      //   write_off_at: null,
      //   write_off_detail: [_.cloneDeep(WRITEOFFDETIALITEM)],
      // },
      // writeOffSecondSubjects: [{}],
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
    ]),

    setupModel (data) {
      data.payment_detail.forEach((item, index) => {
        if (this.model.write_off_detail.length === index) {
          this.addDetailItem()
        }
        this.writeOffFirstSubjectChange(item.first_subject, index)
        this.setupWriteOffDetailAt(item, index)
      })
    },
    setupWriteOffDetailAt (item, index) {
      const writeOffDetail = this.model.write_off_detail[index]
      writeOffDetail.id = item.id
      writeOffDetail.project_id = item.project_id
      writeOffDetail.project_name = item.project_id > 0 ? this.projectNames[item.project_id] : ''
      writeOffDetail.project_number = item.project_number
      writeOffDetail.department_id = item.department_id
      writeOffDetail.department_name = item.department_name
      writeOffDetail.first_subject = item.first_subject
      writeOffDetail.second_subject = item.second_subject
      writeOffDetail.amount = item.amount
      writeOffDetail.desc = item.desc
      if (item.project_number && Number(item.project_id)) {
        if (item.project_number[0] === 'H') {
          writeOffDetail.canSelectDepartment = true
        } else {
          writeOffDetail.canSelectDepartment = false
        }
      } else {
        writeOffDetail.canSelectDepartment = true
      }
      if (parseInt(item.project_id) === 0) {
        writeOffDetail.project_id = null
      }
      if (parseInt(item.department_id) === 0) {
        writeOffDetail.department_id = null
      }
    },
    changeProject (val, index) {
      this.model.write_off_detail[index].project_id = val.id
      this.model.write_off_detail[index].project_name = val.name
      this.model.write_off_detail[index].project_number = val.number

      let canSelectDepartment = true
      if (val === '') {
        canSelectDepartment = true
      } else {
        if (val.number.length > 0) {
          const projectNumberFirstChart = val.number[0]
          if (projectNumberFirstChart === 'H') { // 项目编号首字母为H
            canSelectDepartment = true
          } else { // 禁用 费用承担部门
            this.model.write_off_detail[index].department_id = null
            canSelectDepartment = false
          }
        }
      }
      this.model.write_off_detail[index].canSelectDepartment = canSelectDepartment
    },
    addDetailItem () {
      this.model.write_off_detail.push(_.cloneDeep(WRITEOFFDETIALITEM))
      this.writeOffSecondSubjects.push({})
    },
    removeDetailItem (index) {
      this.model.write_off_detail.splice(index, 1)
    },
    writeOffFirstSubjectChange (val, index) {
      this.model.write_off_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.writeOffAssociatedRelationships[val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.writeOffSecondSubjects[index] = secondSubjects
    },
    writeOffInvoiceTypeChange (val, index) {
      if (val === 1) {
        this.model.write_off_detail[index].tax_rate = 0
      } else {
        this.model.write_off_detail[index].tax_rate = null
      }
    },
    checkPaymentDetail () {
      if (!this.model.write_off_at) {
        this.$message.error('请选择冲销日期')
        return false
      }
      let list = this.model.write_off_detail
      let rule = {
        first_subject: '一级科目',
        second_subject: '二级科目',
        amount: '含税金额',
        desc: '摘要',
      }
      for (let i = 0; i < list.length; i++) {
        for (const ruleKey in rule) {
          if (!list[i][ruleKey]) {
            this.$message.error(rule[ruleKey] + '不能为空！')
            return false
          }
        }
        if (list[i].tax_rate > 100 || list[i].tax_rate < 0) {
          this.$message.error('请输入正确的税率,范围0 ~ 100！')
          return false
        }
        let projectNumberFirstChart = ''
        if (list[i].project_number && typeof list[i].project_number === 'string') {
          projectNumberFirstChart = list[i].project_number.substr(0, 1)
        }
        if (projectNumberFirstChart === 'H' || !list[i].project_number) { // 项目编号首字母为H或者无编号
          if (!list[i].department_id) {
            this.$message.error('请选择费用承担部门！')
            return false
          }
        }
        if (!list[i].invoice_count && !this.isBatch && !this.isPrepaymentType) {
          this.$message.error('请填写发票张数')
          return false
        }
      }
      return true
    },
    onSubmit () {
      this.checkPaymentDetail() && this.$refs.form.validate((valid) => {
        if (valid) {
          this.writeOffApplication(this.id)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    writeOffApplication (id) {
      request.common('writeOffApplication', {id, ...this.getWriteOffForm()}).then((res) => {
        this.$confirm('冲销成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.setForm(this.id)
          this.$refs.form.resetFields()
          this.$refs.upload.clearFiles()
        }, () => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    onCancel () {
      this.$router.back()
    },

    // 费用承担部门
    searchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {...name, is_disabled: 0})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },

  },
}
</script>

<style lang="scss" scoped>

.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/payment-manager/components/PaymentWriteOffForm.vue